import { render } from "./Digestive.vue?vue&type=template&id=38a51ad4"
import script from "./Digestive.vue?vue&type=script&lang=js"
export * from "./Digestive.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__